var L = /* @__PURE__ */ ((I) => (I.FILE_INVALID_TYPE = "invalid-type", I.FILE_MAX_FILES = "max-files", I.FILE_TOO_LARGE = "too-large", I))(L || {});
export {
  L as ERROR
};
//# sourceMappingURL=FileUploader.constants.es.js.map
